import React from 'react';
import style from './acceptTAndCs.module.scss';
import { FormattedMessage } from 'react-intl';
import { ErrorsDisplay } from 'acscp/components/common/errorsDisplay';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';
import { ACS_PRIVACY_POLICY } from 'acscp/settings/appSettings';
import { LabeledCheckbox } from 'acscp/components/common/labeledCheckbox';

interface AcceptTAndCsProps {
    toggleTAndCsFunction: (event: React.ChangeEvent<HTMLInputElement>) => void;
    showErrors: boolean;
    borderedBox: boolean;
    acceptTAndCsIsChecked?: boolean;
}

const messages = defineMessages({
    error: {
        id: 'components.common.acceptTAndCs.error',
        defaultMessage:
            'To proceed, please tick the box agreeing that ACS can ‘process and retain’ ' +
            'the personal information you have provided.'
    }
});

export class AcceptTAndCsWithIntl extends React.Component<AcceptTAndCsProps & InjectedIntlProps, {}> {
    render(): JSX.Element {
        const privacyPolicy = (
            <a className={style.PrivacyPolicy} href={ACS_PRIVACY_POLICY} target="_blank">
                <FormattedMessage
                    id={'components.common.acceptTAndCs.privacyPolicy'}
                    defaultMessage={'Privacy Policy'}
                />
            </a>
        );

        return (
            <div>
                <LabeledCheckbox
                    containerClassname={style.Checkbox}
                    label={
                        <FormattedMessage
                            id={'components.common.acceptTAndCs.TAndCsAccept'}
                            defaultMessage={
                                    'I agree that by creating an account ACS can process ' +
                                    'and retain my personal information as stated within their ' +
                                    '{privacyPolicy} for the purpose of providing services; ' +
                                    'or confirm that I have authority to provide personal information ' +
                                    'about a third party individual for ACS to process and retain.'
                            }
                            values={{privacyPolicy}}
                        />
                    }
                    rightAlignCheckbox={false}
                    darkBox={false}
                    borderedBox={this.props.borderedBox}
                    highlightError={false}
                    onChange={this.props.toggleTAndCsFunction}
                    checked={!!this.props.acceptTAndCsIsChecked}
                />
                {
                    (!this.props.acceptTAndCsIsChecked && this.props.showErrors) &&
                    <ErrorsDisplay
                        errors={[this.props.intl.formatMessage(messages.error)]}
                    />
                }
            </div>
        );
    }
}

export const AcceptTAndCs = injectIntl(AcceptTAndCsWithIntl);
